import { IMPACT_ANALYSIS_ROUTE } from './routes'

export const impactNavItems = [
  {
    labelKey: 'shell.nav.impactAnalysis',
    icon: 'chart-line-up',
    navKey: 'impactAnalysis',
    to: IMPACT_ANALYSIS_ROUTE,
    visibility: { control: 'flag' as const, id: 'causal_impact' },
  },
]
